import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { styled, alpha } from "@mui/material/styles";
import { Box, Link, Drawer, Typography } from "@mui/material";
import account from "../../../_mock/account";
import useResponsive from "../../../hooks/useResponsive";
import Scrollbar from "../../../components/scrollbar";
import NavSection from "../../../components/nav-section";
import navConfig from "./config";

import avatarMen from "../../../asset/images/avatar-men.webp";
import RegisterUserModal from "../../../pages/admin/register-user-modal";

const NAV_WIDTH = 280;

const StyledAccount = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: alpha(theme.palette.grey[500], 0.12),
}));

ExpertNav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function ExpertNav({ openNav, onCloseNav }) {
  const { pathname } = useLocation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isDesktop = useResponsive("up", "lg");

  const handleRegisterUserClick = () => {
    setIsModalOpen(true);
  };

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
  }, [pathname]);

  const adminItems = navConfig.slice(0, 8);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        "& .simplebar-content": {
          height: 1,
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <Box sx={{ px: 2.5, py: 1, display: "inline-flex" }} />

      <Box sx={{ mb: 5, mx: 2.5 }}>
        <Link underline="none">
          <StyledAccount style={{ backgroundColor: "#084638" }}>
            <img
              src={avatarMen}
              alt="Not found"
              className="img-fluid"
              width="40px"
              style={{ borderRadius: "50%" }}
            />
            <Box sx={{ ml: 2 }}>
              <Typography
                className="text-white"
                variant="subtitle2"
                sx={{
                  color: "text.primary",
                  fontSize: "25px",
                  fontFamily: "Neo Sans Regular",
                }}
              >
                {account.displayName}
                <br />
              </Typography>
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                {account.role}
              </Typography>
            </Box>
          </StyledAccount>
        </Link>
      </Box>

      <NavSection
        data={adminItems}
        onRegisterUserClick={handleRegisterUserClick} // 👈 pass the handler
      />

      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <>
      <Box
        component="nav"
        sx={{
          flexShrink: { lg: 0 },
          width: { lg: NAV_WIDTH },
          zIndex: "1",
        }}
      >
        {isDesktop ? (
          <Drawer
            open
            variant="permanent"
            PaperProps={{
              sx: {
                width: NAV_WIDTH,
                bgcolor: "background.default",
                borderRightStyle: "solid",
                fontFamily: "Neo Sans Regular",
              },
            }}
          >
            {renderContent}
          </Drawer>
        ) : (
          <Drawer
            open={openNav}
            onClose={onCloseNav}
            ModalProps={{
              keepMounted: true,
            }}
            PaperProps={{
              sx: { width: NAV_WIDTH },
            }}
          >
            {renderContent}
          </Drawer>
        )}
      </Box>

      {/* Register User Modal here */}
      <RegisterUserModal
        isOpen={isModalOpen}
        toggle={() => setIsModalOpen(false)}
      />
    </>
  );
}
